import { routes } from '../config/api_routes'
import { multipart_headers } from '../Helper/helper';

export const productService = {

    getProduct: (formData) => {    
        return window.axios.post(routes.getProductApi,formData)
    },
    getTaxes: (formData) => {    
        return window.axios.post(routes.getTaxes,formData)
    },
    getMainCategory: (formData) => {    
        return window.axios.post(routes.getMainCategoryApi,formData)
    },
    getSubCategory: (formData) => {    
        return window.axios.post(routes.getSubCategoryApi,formData)
    },
    getProductBrand: (formData) => {    
        return window.axios.post(routes.getProductBrandyApi,formData)
    },
    getAllProductBrand: (formData) => {    
        return window.axios.post(routes.getAllProductBrandApi,formData)
    },
    addProduct: (formData) => {    
        return window.axios.post(routes.addProductApi,formData)
    },
    getProductById: (formData) => {    
        return window.axios.post(routes.getProductByIdApi,formData)
    },
    editProduct: (formData) => {    
        return window.axios.post(routes.editProductApi,formData)
    },
    deleteProduct: (formData) => {    
        return window.axios.post(routes.deleteProductApi,formData)
    },
    getSubProduct: (formData) => {    
        return window.axios.post(routes.getSubProductApi,formData)
    },
    getProductTag: (formData) => {    
        return window.axios.post(routes.getProductTagApi,formData)
    },
    addSubProduct: (formData) => {    
        return window.axios.post(routes.addSubProductApi,formData)
    },
    getSubProductById: (formData) => {    
        return window.axios.post(routes.getSubProductByIdApi,formData)
    },
    deleteSubProduct: (formData) => {    
        return window.axios.post(routes.deleteSubProductApi,formData)
    },
    updateSubProductOrder: (formData) => {
        return window.axios.post(routes.updateSubProductOrderApi, formData)
    },
    getCatAttribute: (formData) => {    
        return window.axios.post(routes.getCatAttributeApi,formData)
    },
    editSubProduct: (formData) => {    
        return window.axios.post(routes.editSubProductApi,formData)
    },
    getSearchProduct: (formData) => {    
        return window.axios.post(routes.getSearchProductApi,formData)
    },
    getSearchProductByNameApi: (formData) => {    
        return window.axios.post(routes.getSearchProductByNameApi,formData)
    },
    getSearchSubCategory: (formData) => {    
        return window.axios.post(routes.getSearchSubCategoryApi,formData)
    },
    getRefundPrice: (formData) => {    
        return window.axios.post(routes.getRefundPriceApi,formData)
    },
    getProductBox: (formData) => {    
        return window.axios.post(routes.getProductBoxApi,formData)
    },
    updateSubProductQuantity: (formData) => {    
        return window.axios.post(routes.updateSubProductQuantityApi,formData)
    },
}